import { Component, OnInit } from '@angular/core';
import { DashCodeHelper } from '@app/_shared/_helpers/dashcode.helper';

@Component({
  selector: 'dashlayout-header-toggletheme',
  templateUrl: './toggletheme.component.html',
  styleUrls: ['./toggletheme.component.scss']
})
export class TogglethemeComponent implements OnInit {
  currentTheme= "light"
  constructor(private DashcodeHelper:DashCodeHelper) { }

  ngOnInit(): void {
    this.DashcodeHelper.applyTheme();
  }
  changeTheme(){
    if (this.currentTheme === "light") {
      this.currentTheme = "dark";
    } else {
      this.currentTheme = "light";
    }
    localStorage.theme = this.currentTheme;
    this.DashcodeHelper.applyTheme();

  }
  
  
}
